<div class="jas-dialog" role="dialog" aria-labelledby="jas-title">
  <h2 id="jas-title" class="jas-title">We’ll set SuperSee up with you</h2>
  <p class="jas-body">
    We’ll reach you on this account to walk through setup. You can keep installing on this computer in the meantime.
  </p>

  <div class="jas-phone" *ngIf="needsPhoneCapture">
    <p class="jas-phone-lead">We’ll call or message this number to set SuperSee up with you.</p>
    <app-journey-contact-phone-strip
      #assistedPhoneStrip
      variant="ready"
      source="assisted_setup"
      hint="Mobile number for your setup call"
      [showSkip]="false"
      [phoneValue]="draftPhone"
      (phoneChange)="onPhoneDraft($event)"
      (saved)="onPhoneSaved($event)" />
  </div>

  <p class="jas-error" *ngIf="error">{{ error }}</p>
  <div class="jas-actions">
    <button type="button" class="jas-secondary" [disabled]="submitting" (click)="cancel()">Not now</button>
    <button type="button" class="jas-primary" [disabled]="submitting" (click)="confirm()">
      {{ submitting ? 'Sending…' : 'Get a setup call' }}
    </button>
  </div>
</div>
